export const environment = {
  test: 'dev',
  envName: 'local',
  version: '1.0.0',
  appName: 'admin-front-browser',
  grafanaFaroDataSource: 'https://alloy-faro.k8s-cnc.anotaai-platform-production.com',
  grafanaFaroApiKey: 't@2sis0c3d&Lsi6lyis?',
  ANOTAAI_ADMIN_URL: 'https://preprod-admin-front.anota-ai.com',
  redirectUrl: 'https://staging-register-frontend.anota-ai.com',
  BACKEND_URL: 'https://staging-freemium-api.anota-ai.com',
  UUID_KEY: '6369373afb084793432f927d',
  INBOUND_URL: 'https://staging-inbound.anota-ai.com',
  ANOTAAI_RESPONDE_DOWNLOAD_URL: 'https://staging-app.anota-ai.com/download-app/anotaai-desktop',
  GOOGLE_PLAY_APP_URL: 'https://play.google.com/store/apps/details?id=ai.anota.android',
  INSTALL_APP_REDIRECT_URL: 'https://instalar.anota.ai/aplicativo',
  ONE_LINK_REDIRECT_URL: 'https://encurta.anota.ai/aplicativo',
  gtmId: 'GTM-MKQBRXH',
  BOT_MOBILE_URL: 'https://staging-bot-mobile.anota-ai.com',
  ANOTAAI_DESKTOP_URL: 'http://127.0.0.1:420',
  AMPLITUDE_KEY: '7757097bd324d71343ab85a93839f5cf',
  ANOTAAI_RESPONDE_PROTOCOL: 'anotaaistg',
  landingPageUrl: 'https://wordpress-lp.staging.dc.anota.ai/home/',
  AMPLITUDE_EXPERIMENT_KEY: "client-3lC5YW0mQPKSwzxXFt23brNraUWybpJQ",
  SYSTEM_USAGE: "https://staging-system-usage.api.anota-ai.com",
  RECAPTCHA_KEY: '6Lexaq8sAAAAAH54YBnXh6rzPfeE2lfOCV213JoB'
};
